<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Mission Users</h4>
      </div>
      <div class="modal-body">
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>User ID</th>
              <th>Progress Quantity</th>
              <th>Reward Granted</th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading) {
              <tr>
                <td colspan="4" class="text-center">
                  <span class="spinner-border spinner-border-sm"></span> Loading...
                </td>
              </tr>
            } @else {
              @for (user of users; track user.userId; let i = $index) {
                <tr>
                  <td>{{ (page - 1) * resultsPerPage + i + 1 }}</td>
                  <td>{{ user.userId }}</td>
                  <td>{{ user.missionProgressQuantity }}</td>
                  <td>
                    @if (user.isRewardGranted) {
                      <span class="badge bg-success">Yes</span>
                    } @else {
                      <span class="badge bg-secondary">No</span>
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (page - 1) * resultsPerPage + 1 }} to {{ (page - 1) * resultsPerPage + users.length }} of {{ totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="page <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="page <= 1">&laquo;</button>
            </li>
            @for (p of getPageNumbers(); track $index) {
              @if (p === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="p === page">
                  <button class="page-link" (click)="goToPage(p)">{{ p }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="page >= totalPages">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="page >= totalPages">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>
